class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.detailsElements = this.querySelectorAll('details');
    this.closeTimers = new WeakMap();

    this.detailsElements.forEach((detailsElement) => {
      detailsElement.addEventListener('pointerenter', () => this.openDetails(detailsElement));
      detailsElement.addEventListener('pointerleave', () => this.closeDetails(detailsElement));
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  openDetails(detailsElement) {
    window.clearTimeout(this.closeTimers.get(detailsElement));
    this.closeSiblingDetails(detailsElement);
    detailsElement.setAttribute('open', '');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', true);
  }

  closeDetails(detailsElement) {
    this.closeTimers.set(
      detailsElement,
      window.setTimeout(() => {
        if (detailsElement.matches(':hover') || detailsElement.contains(document.activeElement)) return;

        detailsElement.removeAttribute('open');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      }, 120)
    );
  }

  closeSiblingDetails(detailsElement) {
    detailsElement
      .closest('ul')
      ?.querySelectorAll(':scope > li > details[open]')
      .forEach((siblingDetailsElement) => {
        if (siblingDetailsElement === detailsElement) return;

        siblingDetailsElement.removeAttribute('open');
        siblingDetailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      });
  }
}

customElements.define('header-menu', HeaderMenu);
